import DoublePopoverConfirm from "@/components/DoublePopoverConfirm/DoublePopoverConfirm";
import useTranslation from "@/hooks/useTranslation";
import { message } from "antd";
import { ReactNode } from "react";
import {
  useDeleteBusinessTravel,
  useDeleteBusinessTravelAll,
} from "@/pages/employee/business_travel/useBusinessTravel";
import { ExclamationCircleFilled } from "@ant-design/icons";

export default function DeleteBusinessTravelAction({
  year,
  disabled = false,
  children,
  onSuccess,
}: {
  year?: number;
  disabled?: boolean;
  children: ReactNode;
  onSuccess?: () => void;
}) {
  const translation = useTranslation();

  const deleteBusinessTravel = useDeleteBusinessTravel();
  const deleteBusinessTravelAll = useDeleteBusinessTravelAll();

  const deleteAll = async () => {
    await deleteBusinessTravelAll.mutateAsync();
  };

  const deleteYear = async () => {
    await deleteBusinessTravel.mutateAsync({ year });
  };

  return (
    <DoublePopoverConfirm
      trigger={["click"]}
      title={"Delete business travel"}
      description={
        <>
          <p>Are you sure you want to delete business travel data?</p>
          <p style={{ color: "#F5222D" }}>This action can not be undone.</p>
        </>
      }
      icon={<ExclamationCircleFilled style={{ color: "#F5222D" }} />}
      onConfirm1={() =>
        deleteAll()
          .then(() => {
            onSuccess && onSuccess();
          })
          .catch(() => message.error(translation.errors.general))
      }
      onConfirm2={
        year
          ? () =>
              deleteYear()
                .then(() => {
                  onSuccess && onSuccess();
                })
                .catch(() => message.error(translation.errors.general))
          : undefined
      }
      placement="bottom"
      button1Props={{
        children: "Delete all business travel",
        danger: true,
      }}
      button2Props={{
        children: `Delete ${year} business travel`,
        danger: true,
      }}
      cancelButtonProps={{ children: "Cancel" }}
      disabled={disabled}
    >
      {children}
    </DoublePopoverConfirm>
  );
}
